export const KEY_CODES = {
  // Actions
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
  TAB: 'Tab',
  // Navigation
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  END: 'End',
  HOME: 'Home',
  // Characters
  SLASH: '/',
}
